// src/components/ToastNotification.js

import React from 'react'
import { ToastContainer, Slide } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useAppMode } from '../contexts/AppModeContext'

const ToastNotification = () => {
  const { isAppMode } = useAppMode()

  if (isAppMode) {
    return (
      <>
        <ToastContainer position="bottom-center" autoClose={2500} hideProgressBar newestOnTop closeOnClick={true} closeButton={false} rtl={false} pauseOnFocusLoss={false} draggable={false} pauseOnHover={false} icon={false} transition={Slide} limit={2} theme="dark" toastClassName="app-toast" className="app-toast-container" />
        <style>{`
          .app-toast-container {
            padding: 0 16px;
            bottom: calc(84px + env(safe-area-inset-bottom, 0px));
            width: 100%;
            max-width: 560px;
            left: 50%;
            transform: translateX(-50%);
            pointer-events: none;
            text-align: center;
          }
          .app-toast-container .Toastify__toast {
            pointer-events: auto;
            display: block;
            width: fit-content;
            max-width: 100%;
            min-height: 0;
            padding: 12px 20px;
            margin: 0 auto 10px;
            border-radius: 14px;
            background: rgba(17, 24, 39, 0.92);
            color: #fff;
            font-family: inherit;
            font-size: 13.5px;
            font-weight: 500;
            line-height: 1.4;
            text-align: center;
            cursor: pointer;
            box-shadow: 0 8px 24px rgba(0,0,0,0.22);
            backdrop-filter: saturate(160%) blur(6px);
            -webkit-backdrop-filter: saturate(160%) blur(6px);
          }
          .app-toast-container .Toastify__toast-body {
            padding: 0;
            margin: 0;
            white-space: normal;
            word-break: break-word;
          }
          .app-toast-container .Toastify__toast--success { background: rgba(22, 163, 74, 0.95); }
          .app-toast-container .Toastify__toast--error   { background: rgba(220, 38, 38, 0.95); }
          .app-toast-container .Toastify__toast--warning { background: rgba(217, 119, 6, 0.95); color: #fff; }
          .app-toast-container .Toastify__toast--info    { background: rgba(31, 41, 55, 0.95); }
          .app-toast-container .Toastify__progress-bar--wrp { opacity: 0 !important; }
        `}</style>
      </>
    )
  }

  return (
    <ToastContainer
      position="top-left" // You can adjust the position as needed
      autoClose={4000} // Auto close time (in milliseconds)
      hideProgressBar={false} // Whether or not to hide the progress bar
      newestOnTop={false} // Stack toasts on top or not
      closeOnClick={true} // Allow clicking the toast to close
      rtl={false} // Right to Left (set true for RTL languages)
      pauseOnFocusLoss={false} // Pause toast when window loses focus
      draggable={true} // Allow dragging the toast
      pauseOnHover={true} // Pause toast when hovered over
    />
  )
}

export default ToastNotification
